import { useTranslation } from "react-i18next";
import './dropdown.scss';

function DropdownAtom(props) {
	const { id, label, className, placeholder, value, options = [], hideNoOptionSelect = false, onChange, error = '', required = false, sortOptions = true, disabled = '', shouldTranslate = false } = props;
	const { t } = useTranslation();

	// Generate a unique id if not provided
	const selectId = id || `dropdown-${Math.random().toString(36).substr(2, 9)}`;

	const getOptions = () => {
		if (!sortOptions) {
			return options;
		}
		return options.sort((op1, op2) => {
			return op1.label.localeCompare(op2.label);
		})
	}

	const selectClassName = `${className || "form-control"}`.trim();

	return (
		<>
			{label ? <label htmlFor={selectId}>{label}</label> : ''}

			<select
				id={selectId}
				className={selectClassName}
				value={value}
				disabled={disabled}
				aria-label={!label ? (placeholder || 'Select') : undefined}
				onChange={onChange}>
				{hideNoOptionSelect ? '' : <option value=''>{(required ? `${placeholder}*` : placeholder) || 'Select'}</option>}
				{getOptions().map((option) => {
					return <option value={option.value} key={option.value}>{shouldTranslate ? t(option.label) : option.label}</option>
				})}
			</select>
			{error ? <p className="text-danger">{t(error)}</p> : ''}
		</>
	);
}

export default DropdownAtom;
